// extracted by mini-css-extract-plugin
export default {"form":"FormPokemon_form__IqTwu","input":"FormPokemon_input__+TbAb","buttom":"FormPokemon_buttom__F2qEU"};